<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { config } from './config';

export default {
  name: "app",
  mounted() {
    if (config.userInactivity.enabled) {
      this.initIdleTimer();
    }
  },

  methods: {
    initIdleTimer() {
      if (this._idleInitialized) return;
      this._idleInitialized = true;

      let timer = null;

      const reset = () => {
        clearTimeout(timer);

        timer = setTimeout(() => {
          if(this.$route.path != "/login") {
            this.$store.dispatch("authentication/logout", {
              impersonateUser: false
            });
          }
        }, config.userInactivity.timeout);
      };

      const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];
      events.forEach(e => window.addEventListener(e, reset));

      reset();
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>